import React from "react";

function SortingRuleChip({ value }) {
  if (value === "Size sort required") {
    return <span className="pg-chip pg-chip--size-sort">{value}</span>;
  }
  if (value === "Std palletise") {
    return <span className="pg-chip pg-chip--std-palletise">{value}</span>;
  }
  return <span>{value}</span>;
}

export default SortingRuleChip;
